import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Typography } from '@material-ui/core';
import useStyles from './useStyles';

export const ResourceRequestChartBanner = ({
  messageId,
  children,
  classes: classesOverride
}) => {
  const classes = useStyles({ classes: classesOverride });

  return (
    <div className={classes.root2}>
      <Typography variant="subtitle2">
        <FormattedMessage id={messageId} />
      </Typography>
      {children && <div className={classes.buttons}>{children}</div>}
    </div>
  );
};

ResourceRequestChartBanner.propTypes = {
  messageId: PropTypes.string.isRequired,
  children: PropTypes.node,
  classes: PropTypes.object
};
export default ResourceRequestChartBanner;
